var _path, _polygon, _polygon2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8X(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "basic",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 2,
      strokeMiterlimit: 10
    },
    d: "M39,45H11c-3.314,0-6-2.686-6-6V11 c0-3.314,2.686-6,6-6h28c3.314,0,6,2.686,6,6v28C45,42.314,42.314,45,39,45z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.914,37h-7.937L13.086,13h7.937L37.914,37z M31.022,35h3.063L19.978,15h-3.063L31.022,35z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "15.5,37 23.973,27.08 22.844,25.476 13,37 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "26.115,21.646 27.244,23.251 36,13 33.5,13 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8X);
export default __webpack_public_path__ + "static/media/icons8-x.2f4cb4c917e71c27150e4ade67d36f8a.svg";
export { ForwardRef as ReactComponent };